import MetricsService from '../services/metricsService';
import { AVRProducts } from '@/utils/enums';
import productRoutes from '@/utils/enums/productRoutes';

const actions = {
  logModalImpression(context, payload) {
    return MetricsService.logModalImpression(payload);
  },
  logModalInteraction({ rootState, rootGetters }, payload) {
    const data = {
      product: rootGetters.getCurrentProduct,
      apiKey: rootState.business.api.key,
      externalId: rootState.business.api.externalID,
      payload: {
        deviceType: rootGetters.getCurrentBaseRoute,
        vin: rootState.route.query.vin,
        referralType: rootGetters.getReferralType,
        ...payload,
      },
    };

    // Is it spotlight report application?
    const isSpotlightReport = !!rootState.route.meta.spotlightReport;
    if (isSpotlightReport) {
      data.payload.elementInteractedWith = `report__${payload.elementInteractedWith}`;
    }

    switch (data.payload.elementInteractedWith) {
      case 'cim.applyForFinancingStart':
      case 'cim.viewedCIMVehicleDetails':
      case 'cim.applyForFinancingComplete':
        data.payload.leadId = rootState.lead.leadId;
        break;
      default:
    }
    return MetricsService.logModalInteraction(data);
  },
  logModalElementRendered({ rootState, rootGetters }, payload) {
    const product = typeof rootGetters.getCurrentProduct === 'string' ? rootGetters.getCurrentProduct : 'none';
    const data = {
      product,
      apiKey: rootState.business.api.key,
      externalId: rootState.business.api.externalID,
      payload: {
        deviceType: rootGetters.getCurrentBaseRoute,
        vin: rootState.route.query.vin,
        view: rootState.route.path,
        widgetId: rootState.route.query.widgetId ?? null,
        referralType: rootGetters.getReferralType,
        ...payload,
      },
    };

    return MetricsService.logModalElementRendered(data);
  },
  logWidgetInteraction({ rootState, rootGetters }, payload) {
    let product = typeof rootGetters.getCurrentProduct === 'string' ? rootGetters.getCurrentProduct : 'none';
    // rename to tradein
    if (product === AVRProducts.TRADE) {
      product = productRoutes.TRADE;
    }
    const data = {
      product,
      apiKey: rootState.business.api.key,
      externalId: rootState.business.api.externalID,
      payload: {
        condition: rootState.route.query.condition ?? null,
        deviceType: rootGetters.getCurrentBaseRoute,
        referrerUrl: rootState.route.query.referrer_url ?? null,
        vin: rootState.route.query.vin,
        widgetId: rootState.route.query.widgetId ?? null,
        referralType: rootGetters.getReferralType,
        ...payload,
      },
    };

    return MetricsService.logWidgetInteraction(data);
  },
};

export default {
  namespaced: true,
  actions,
};
